// A time zone on the wire and in a file — an IANA name, checked the ONE way
// (ADR-030 §Timezone · ADR-082 §3): the runtime ACCEPTS it as a zone, never
// membership in `Intl.supportedValuesOf('timeZone')` — that list omits UTC and
// swaps canonical and legacy aliases between ICU builds. Two runtimes must
// accept it where both exist: Intl (construct a formatter; a RangeError means
// no) and Temporal, the engine the server cuts days with — ICU's Intl still
// takes a few retired names (`SystemV/*`, `US/Pacific-New`) Temporal refuses.
// Both also accept an OFFSET (`+03:00`, or with a Unicode minus), which is no
// zone at all — a clock change moves the zone, never the offset — so the shape
// rule refuses any leading sign. The typed id is kept as typed: an alias is a
// name too. The schema's message is the CODE `INVALID_TIMEZONE`, worded in the
// `errors` words (CONVENTIONS §i18n) — every zone a request carries (a project's,
// a person's, a site's, an import row's) is refused with the one code.
import { z } from 'zod';
const SIGNED_RE = /^[+\-−]/;
const temporal = globalThis.Temporal;
/** true iff `v` is an IANA zone name every runtime here accepts — never an offset. */
export function isIanaZone(v) {
    if (v.trim() !== v || v === '' || SIGNED_RE.test(v))
        return false;
    try {
        new Intl.DateTimeFormat('en', { timeZone: v });
        temporal?.Instant.fromEpochMilliseconds(0).toZonedDateTimeISO(v);
        return true;
    }
    catch {
        return false;
    }
}
// The refine ALONE — no length check beside it: a cell that is no zone gets the one issue, never a second raw one.
export const IanaZoneSchema = z.string().refine(isIanaZone, { message: 'INVALID_TIMEZONE' });
